<template>
  <div class="h-full w-full py-10px">
    <div
      class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
    >
      <span>{{ mode === 'view' ? '计划信息' : mode === 'edit' ? '编辑计划' : '新增计划' }}</span>
    </div>
    <div>
      <el-form :model="formData" ref="planFormRef" label-width="160px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              label="所属项目"
              prop="projectId"
              :rules="[{ required: true, message: '所属项目必填' }]"
            >
              <el-select v-model="formData.projectId">
                <el-option
                  v-for="item in projectOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="关联计划级别"
              prop="level"
              :rules="[{ required: true, message: '关联计划级别必填' }]"
            >
              <el-select v-model="formData.level" @change="changeLevel">
                <el-option
                  v-for="item in levelList"
                  :key="item.id"
                  :value="item.code"
                  :label="item.displayName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="关联计划WBS"
              prop="WBSId"
              :rules="[{ required: true, message: '关联计划WBS必填' }]"
            >
              <el-select v-model="formData.WBSId" @change="changeWBS">
                <el-option
                  v-for="item in levelList"
                  :key="item.id"
                  :value="item.code"
                  :label="item.displayName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="分配部门"
              prop="depart"
            >
              <el-select v-model="formData.depart">
                <el-option
                  v-for="item in projectOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <div
      class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
    >
      <span>里程碑计划编制</span>
    </div>
    <div class="text-right mb-10px">
      <el-button size="mini">计划导入</el-button>
    </div>
    <div class="h-[calc(100%-280px)] mb-10px">
      <el-table height="100%" :data="tableData">
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed || false"
          show-overflow-tooltip
        >
          <template slot-scope="{ column, row, $index }">
            <div v-if="column.property === 'level'">
              <el-select v-model="row[column.property]">
                <el-option
                  v-for="item in levelList"
                  :key="item.id"
                  :value="item.code"
                  :label="item.displayName"
                ></el-option>
              </el-select>
            </div>
            <div v-else-if="column.property === 'personIds'">
              <el-select v-model="row[column.property]">
                <el-option
                  v-for="item in personList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input
                v-if="$index !== 0 && column.property !== 'seqNo'"
                v-model="row[column.property]"
              ></el-input>
              <span v-else>{{ row[column.property] }}</span>
            </div>
          </template>
          <template #header="{ column }">
            <div v-if="['level', 'code', 'name'].includes(column.property)">
              <span class="text-[#F56C6C]">*</span> {{ column.label }}
            </div>
            <span v-else>
              {{ column.label }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="200px" fixed="right">
          <template slot-scope="{ row, $index }">
            <div>
              <el-button
                v-if="row.seqNo.split('.').length !== 3"
                class="mr-10px"
                size="mini"
                @click="addItem(row, $index)"
                >添加</el-button
              >
              <el-button
                v-if="$index !== 0"
                class="mr-10px"
                size="mini"
                @click="deleteItem(row, $index)"
                >删除</el-button
              >
            </div>
          </template></el-table-column
        >
      </el-table>
    </div>

    <div class="text-center">
      <el-button class="mr-0px" type="primary" @click="submit">保存</el-button>
      <el-button>取消</el-button>
    </div>
  </div>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const dataCategoryApi = new DataCategoryApi()

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  data() {
    return {
      formData: {},
      projectOptions: [],
      columns: [
        { prop: 'seqNo', label: '序号', width: 60 },
        { prop: 'code', label: '里程碑名称', width: 180 },
        { prop: 'name', label: '里程碑编码' },
        { prop: 'level', label: '计划开始时间' },
        { prop: 'level', label: '计划结束时间' },
        { prop: 'level', label: '计划工期' },
        { prop: 'level', label: '里程碑描述' },
        { prop: 'personIds', label: '所属机组系统' },
      ],
      tableData: [],
      personList: [],
      levelList: [],
    }
  },
  computed: {
    mode() {
      return this.$route.query.mode
    },
  },
  methods: {
    addItem(row, index) {
      const ar = row.seqNo.split('.')
      const count = this.tableData.filter((o) => {
        return o.seqNo === row.seqNo || o.seqNo.indexOf(`${row.seqNo}.`) === 0
      })
      const lastIndex = _.findLastIndex(this.tableData, (i) => {
        return i.seqNo === count[count.length - 1]?.seqNo
      })
      const ii = lastIndex >= 0 ? lastIndex + 1 : index + 1
      const cr = count[count.length - 1]?.seqNo.split('.')
      this.tableData.splice(ii, 0, {
        seqNo:
          cr && cr.length >= ar.length + 1
            ? `${row.seqNo}.${Number(cr[ar.length]) + 1}`
            : `${row.seqNo}.${count.length}`,
        name: '',
        code: '',
        level: `${ar.length}`,
      })
    },
    deleteItem(row, index) {
      console.log(this.tableData)
      const ar = row.seqNo.split('.')
      const list = this.tableData.filter((e) => {
        return e.seqNo.indexOf(row.seqNo) !== 0
      })
      list.forEach((o) => {
        const or = o.seqNo.split('.')
        if (
          o.seqNo !== ar.slice(0, ar.length - 1).join('.') &&
          o.seqNo.indexOf(ar.slice(0, ar.length - 1).join('.')) === 0 &&
          or[or.length - 1] > ar[ar.length - 1] &&
          or.length === ar.length
        ) {
          const items = list.filter((e) => {
            return e.seqNo.indexOf(o.seqNo) === 0 && e.seqNo !== o.seqNo
          })
          o.seqNo = `${or.slice(0, or.length - 1).join('.')}.${or[or.length - 1] - 1}`
          items.forEach((q, i) => {
            const qr = q.seqNo.split('.')
            q.seqNo = `${o.seqNo}.${qr[qr.length - 1]}`
          })
        }
      })

      this.tableData = list
    },
    changeLevel() {},
    changeWBS() {},
    async getPersonList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && res) {
        this.personList = res.items
      }
    },

    async getLevel() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'scheduleLevel',
        includeDetails: true,
      })
      if (!err) {
        this.levelList = res.dataItems
      }
    },
    async submit() {
      await this.$refs.planFormRef.validate()
      const item = this.tableData.find((o) => {
        return !o.code.trim() || !o.name.trim() || !o.level
      })
      if (item) {
        return this.$message.error(`序号为${item.seqNo}的必填信息为空！`)
      }
    },
  },
  mounted() {
    this.getLevel()
    this.getPersonList()
  },
}
</script>
